const columns = [
  {
    title: 'STT',
    key: 'stt',
  },
  {
    title: 'Mã nhà cung cấp',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Tên nhà cung cấp',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Ngày tạo',
    dataIndex: 'create_date',
    key: 'create_date',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Liên hệ',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Địa chỉ',
    key: 'address',
  },
  {
    title: 'Hành động',
    key: 'action',
  },
]

export default columns
